import { FC, useEffect, useRef, useState } from "react"
import { Trans, useTranslation } from "react-i18next"
import { useParams } from "react-router-dom"

import { UText } from "../../../components"
import { Grid } from "../../../components/mui.components"
import NavigationBlockPopup from "../../../components/NavigationBlockPopup/NavigationBlockPopup"
import { useAppDispatch, useAppSelector } from "../../../core/app/hooks"
import { setIsRouteChangeBlocked } from "../../../core/app/slices/navigationPopup/navigationPopupSlice"
import { RootState } from "../../../core/app/store"
import { useCallbackPrompt } from "../../../hooks/useCallbackPrompt"
import { FormContentRef } from "@/components/Form"
import RxForm from "./RxForm"

const SmartRxForm: FC<{
  isSettings?: boolean
  isResetData?: boolean
  setIsResetData?: (val: boolean) => void
  isSaveData?: boolean
  setIsSaveData?: (val: boolean) => void
  saveTrigger?: number
}> = ({
  isSettings,
  isResetData,
  setIsResetData,
  isSaveData,
  setIsSaveData,
  saveTrigger,
}) => {
  const { t } = useTranslation("common")
  const dispatch = useAppDispatch()
  const { formid } = useParams()
  const { isLoading, formTemplateList } = useAppSelector(
    (state: RootState) => state.formService,
  )
  const formRef = useRef<FormContentRef>(null)

  useEffect(() => {
    const saveDataAsync = async () => {
      if (!isSaveData) return
      if (formRef.current) {
        formRef.current.setShowValidationErrors(true)
        if (formRef.current.showValidationErrors) {
          formRef.current.validateErrors()
        }
      }
    }
    saveDataAsync()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isSaveData, saveTrigger]) // depend on both

  useEffect(() => {
    const resetDataAsync = async () => {
      if (!isResetData) return
      if (formRef?.current?.resetFormData) {
        await formRef?.current?.resetFormData()
        setIsResetData && setIsResetData(false)
        dispatch(setIsRouteChangeBlocked({ isRouteChangeBlocked: false }))
      }
    }
    resetDataAsync()
  }, [isResetData])

  return (
    <>
      <Grid
        container
        flexDirection={"column"}
        sx={{
          backgroundColor: "background.default",
          borderRadius: 2,
          padding: 5,
          justifyContent: "space-between",
          width: "640px",
        }}
      >
        <RxForm
          ref={formRef}
          formid={formid}
          formTemplateList={formTemplateList}
          isSaveData={isSaveData}
          setIsSaveData={setIsSaveData}
        />
      </Grid>
    </>
  )
}

export default SmartRxForm
